import { baseURLEndpoint } from './constant'

export default {
  NAME: 'ArtFix',
  LOGIN_TITLE: 'ArtFix - Login',
  DOMAIN: baseURLEndpoint.substring(0, baseURLEndpoint.length - 6),
  KANBAN: 'https://cmykhubapp.ngine.com.au',
  REGISTER:
    baseURLEndpoint.substring(0, baseURLEndpoint.length - 6) + 'pricing-plans',
}
